import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { Error } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default props => {
    return (
        <ContainerLoading>
            <div>
                <CircularProgress />
            </div>
            <div>{props.label && <LoadingText variant="subititle2">{props.label}</LoadingText>}</div>
        </ContainerLoading>
    );
};

export const ErrorContent =  ({label}) =>{
    const navigation = useNavigate()
    return (
        <ContainerLoading>
            <Stack justifyContent="center" alignItems="center" mb={2}>
                <Error sx={{fontSize:45, color: '#ccc'}} />
                <Typography>{label}</Typography>
            </Stack>
            <div><Button variant="contained" onClick={e=>navigation(-1)} >Voltar</Button></div>
        </ContainerLoading>
    );
}
const ContainerLoading = styled.div`
    padding: 100px;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    height:100%;
`;

const LoadingText = styled(Typography)`
    font-weight: bold;
    font-size: 15px;
    margin-top: 10px;
    display: block;
`;
